module.exports = __webpack_public_path__ + "static/atlaskit-dropdown-menu-81dc80939c1ef7e16b41fbb9389f7f19.png";